import {Profile} from "./profile";
import {Site} from "./site";
import {Speciality} from "./speciality";


export  interface Location{
    name: string;
    nature: string;
    parent: Location;
    fullname: string;
    shortname: string;

};

export interface Phone {
    id?: string;
    numberPhone: string;
};
export interface Address {
    id?: string;
    textAddress?: string;
    location: Location;
    fullname?: string;
    shortname?: string;
}

export interface File {
    id?: string;
    path?: string;
}
export interface Person {
    id?: string;
    firstname: string;
    lastname: string;
    fullname?: string;
    phone?: string;
    picture?: string;
    gender?: string;
    image?: { path: string, id?: number };
    nif?: string;
    nin?: string;
    address?: string;
}

export interface User {
    id?: string;
    email?: string;
    username: string;
    password?: string;
    locale?: string;
    status?: string;
    profile?: Profile;
    token?: string;
    person: Person;
    coverImg?: string;
    password_confirmation?: string;
    passwordDecrypted?: string;
    code?: string;
}

export enum Status {
    ALL = 'all',
    ACTIVE = 'active',
    PENDING = "pending",
    CANCEL = "cancel",
    DECLINED = "declined",
    INACTIVE = "inactive",
    LOCKED = "locked",
    CONFIRMED = "confirmed",
    EXPIRED = "expired",
};

export enum Role {
    SUPER = 'super',
    ADMIN = 'admin',
    AGENT = 'agent',
    RECEPTIONIST = 'receptionist',
    CASHIER = 'cashier',
    AGENT_SUPERVISOR = 'agent supervisor',
    ACCOUNTANT = 'accountant'
};

export enum NotificationType {
    MESSENGER = 'messenger',
    APPOINTMENT = 'appointment',
    ALL = "all"
};


export const locales = [
    {label: 'English', value: 'en'},
    {label: 'Français', value: 'fr'},
    {label: 'Kreyòl', value: 'ht'}
];